import script from "./site-info.vue?vue&type=script&setup=true&lang=js"
export * from "./site-info.vue?vue&type=script&setup=true&lang=js"

import "./site-info.vue?vue&type=style&index=0&id=81235b20&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81235b20"]])

export default __exports__